import { colors as colorsImport } from "@fraction/shared";
import React, { type ReactNode, useCallback } from "react";
import { Link } from "react-router-dom";
import { useLogout, useUpdateLocalUser } from "src/auth/useAuth";
import Header from "src/components/Header";
import { Button } from "src/components/ui/button";
import { Logo } from "src/images";
import { cn } from "src/utilities/shadcnUtils";

const STYLES = {
  helpText: "text-gray-500 text-base pl-2 max-[600px]:hidden",
  headerContainer: "flex justify-between",
  needHelpContainer: "flex items-center",
  actions: "flex",
  logoutButton: "ml-6",

  //
  // New version styling
  //
  container: "min-h-[32px] flex items-center justify-between",
  logoBox:
    "w-[290px] border-solid border-r-0 border-b min-[850px]:border-r min-[850px]:border-b-0 border-gray-200 pl-3 min-[620px]:pl-[44px] min-h-[32px] flex items-center",
  mainBar: "flex justify-end flex-grow items-center min-h-[32px] border-b border-solid border-gray-200",
};

/**
 * @deprecated to be removed - use the default export instead
 */
export const OldDashboardHeader = () => {
  const { logout, isLoggingOut } = useLogout();
  const { isAuthenticated } = useUpdateLocalUser();

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  return (
    <Header>
      <div className={STYLES.headerContainer}>
        <Link to="/">
          <Logo width={120} height={27} color={colorsImport.palette.GREEN} />
        </Link>
        <div className={STYLES.actions}>
          {isAuthenticated && (
            <Button
              variant="outline:green"
              className={cn(STYLES.logoutButton, "w-fit max-[420px]:w-full")}
              onClick={handleLogout}
              pending={isLoggingOut}
            >
              Logout
            </Button>
          )}
        </div>
      </div>
    </Header>
  );
};

const DashboardHeader = ({
  children,
  logoBoxClassName,
}: {
  children?: ReactNode;
  logoBoxClassName?: string;
}) => {
  return (
    <div className={STYLES.container}>
      <div className={cn(STYLES.logoBox, logoBoxClassName)}>
        <Link to="/">
          <Logo width={118} height={22} color={colorsImport.palette.GREEN} />
        </Link>
      </div>
      <div className={STYLES.mainBar}>{children}</div>
    </div>
  );
};

export default React.memo(DashboardHeader);
